import { ReleaseBaseFragment, ReleasePublicStatus } from '@cycle-app/graphql-codegen';

export const isReleasePublished = (release?: Pick<ReleaseBaseFragment, 'publicStatus'>) => {
  return release?.publicStatus === ReleasePublicStatus.Published;
};
